import { SingleQueryProvider } from "components/providers/SingleQueryProvider";
import { urlData } from "utils/url";

export const UrlDataProvider = SingleQueryProvider(urlData);
